/*=========================================================================================
  File Name: module-supplier-actions.js
  Description: Supplier Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	Suppliers: function(state) {
		return state.Suppliers;
	},
	Total: function(state) {
		return state.Total;
	},
	SuppliersLoaded: function(state) {
		return state.SuppliersLoaded;
	},

	getSupplier: function(state) {
		return state.Supplier;
	},

	SuppliersCombobox: function(state) {
		return state.SuppliersCombobox;
	},

	SupplierRisks: function(state) {
		return state.SupplierRisks;
	},

	IsLoadingTotalRecords(state) {
		return state.IsLoadingTotalRecords;
	}
};
